import DefaultComparers from '../../Comparers/DefaultComparers';
import MapComparer from '../../Comparers/MapComparer';
export default function orderBy(array, selector, comparer = DefaultComparers.DefaultComparer) {
    const mapComparer = new MapComparer(selector, comparer);
    return array.sort((a, b) => mapComparer.compare(a, b));
}
